import { type FC, type ReactNode } from 'react';
import { useMenu } from '../useMenu';

type Props = {
    onClose: () => void;
    isOpen?: boolean;
    className?: string;
    closeOnBlur?: boolean;
    children: ReactNode;
};

// be sure to wrap onClose in useCallback if the onClose is declared in a function component body
// do not declare onClose as an inline function in the hook call
export const Menu: FC<Props> = ({ className, isOpen, onClose, closeOnBlur, children }) => {
    const menuRef = useMenu(!!isOpen, onClose, closeOnBlur);
    return (
        <div className={className} role="menu" ref={menuRef}>
            {children}
        </div>
    );
};
